module.exports = __webpack_public_path__ + "static/media/item_05.f910e0fb.jpg";